<template>
<div id="set-wrapper">
  <transition name="fade" mode="out-in">
    <router-view/>
  </transition>
</div>
</template>
<script>
export default {
}
</script>
<style lang="scss" scoped>
#set-wrapper {
}
</style>
